import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';

@Injectable()
export class TranslateService {

  data: any = {};

  constructor(private http: Http) { }

  use(lang: string): Promise<any> {
    let localized = localStorage.getItem('localized');             
    let language = (lang === null || lang === "" || lang === undefined) ? "GB" : lang;

    if(localized === "undefined" || localized === ""){
      language = "GB"; 
    }
    else if(JSON.parse(localized) === false){
      language = "GB";
    }

    const langPath = `assets/i18n/${language || 'GB'}.json`;
      return this.http.get(langPath)
          .toPromise()
          .then(response => {
              this.data = Object.assign({}, response.json() || {});
              return this.data;
          })
          .catch((err) => {
            if(err.status === 404){
              let lang = "GB";
              localStorage.setItem('language',lang);
              this.use(lang);
              console.log("No language file found. switch to " + lang);
            }
          });
  }

  public getData(){
    return this.data;
  }

  public getOpcoPlaceholder() {
    return this.data["OPCOVIEWLABELS"]["HEADING"];
  }

  public getGender(gender) {
    return this.data["USERUPDATEVIEWLABELS"]["GENDER_OPTIONS"][gender];
  }

  public getKYCStatus(status) {
    return this.data["KYCUPDATEVIEWLABELS"]["STATUS_OPTIONS_SHOWN_VALUES"][status];
  }

  public getIdType(type) {
    if (type && this.data["ID_TYPE"]["ID_TYPE_SHOWN_VALUES"][type]){
      return this.data["ID_TYPE"]["ID_TYPE_SHOWN_VALUES"][type];
    }    
  }

  public checkAPIErrorExistsByCode(code){
    if(this.data['API_ERROR'] && this.data['API_ERROR'].hasOwnProperty(code)){
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/translate.service.ts